import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';
import storage from '@/utils/storage';

export const refreshAccessToken = async (refresh_token: string): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/v2/auth/refresh?refresh_token=${refresh_token}`);
    return response;
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw error;
  }
};

export const useRefreshAccessToken = ({ config } = {} as { config?: any }) => {
  const { addNotification } = useNotificationStore();

  return useMutation<any, Error, string>({
    mutationFn: refreshAccessToken,
    onError: (error) => {
      console.error('Token refresh failed:', error);
      addNotification({
        type: 'error',
        title: 'Failed to refresh token',
        message: error.message,
      });
    },
    onSuccess: (data) => {
      // Store new tokens if present in response
      if (data?.data?.tokens) {
        const { access_token, id_token } = data.data.tokens;

        if (access_token) {
          storage.setAccessToken(access_token);
        }

        if (id_token) {
          storage.setIdToken(id_token);
        }
      } else if (data?.tokens) {
        // Alternative response structure
        const { access_token, id_token } = data.tokens;

        if (access_token) {
          storage.setAccessToken(access_token);
        }

        if (id_token) {
          storage.setIdToken(id_token);
        }
      } else {
        console.warn('No tokens found in refresh response:', data);
      }
    },
    ...config,
  });
};
